import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';

interface Episode {
  id: number;
  title: string;
  description: string;
  duration: string;
  date: string;
  image: string;
  category: string;
  isPlaying: boolean;
  youtubeUrl: string;
  spotifyUrl: string;
}

interface Short {
  id: number;
  title: string;
  description: string;
  duration: string;
  views: string;
  image: string;
  youtubeUrl: string;
}

export default function EpisodesPage() {
  const [playingEpisode, setPlayingEpisode] = useState<number | null>(null);
  const [hoveredShort, setHoveredShort] = useState<number | null>(null);

  const episodes: Episode[] = [
    {
      id: 1,
      title: "THE CHOP UP W | Kendrick Jones",
      description: "An inspiring conversation with Kendrick Jones about his journey, mindset, and the hustle behind his success. Dive deep into the strategies that drive peak performance.",
      duration: "31:43",
      date: "Dec 10, 2024",
      image: "https://i.ytimg.com/vi/Xv7YCVwdun0/hqdefault.jpg",
      category: "Interview",
      isPlaying: false,
      youtubeUrl: "https://youtu.be/Xv7YCVwdun0",
      spotifyUrl: "https://open.spotify.com/episode/4rOoJ6Egrf8K2IrywzwOMk"
    },
    {
      id: 2,
      title: "MHP Episode 44 : RHYTHM & HUSTLE ~ Masters of the Tables",
      description: "Dive into the world of rhythm and hustle with the masters of the tables. Learn about the dedication, skill, and passion that drives success in the music industry.",
      duration: "45:22",
      date: "Nov 28, 2024",
      image: "https://i.ytimg.com/vi/UDKpeZu8Bqg/hqdefault.jpg",
      category: "Interview",
      isPlaying: false,
      youtubeUrl: "https://youtu.be/UDKpeZu8Bqg",
      spotifyUrl: "https://open.spotify.com/episode/0VgO2pM4eugqC5c8UVynsP"
    },
    {
      id: 3,
      title: "The Chop Up: The Hustle Behind Beastmode Co | BE MORE CONSISTENT",
      description: "Explore the entrepreneurial journey behind Beastmode Co and discover the secrets to building consistency in business and life. A must-watch for aspiring entrepreneurs.",
      duration: "8:31",
      date: "Nov 21, 2024",
      image: "https://i.ytimg.com/vi/Z_mZ6EFQDfQ/hqdefault.jpg",
      category: "Business",
      isPlaying: false,
      youtubeUrl: "https://youtu.be/Z_mZ6EFQDfQ",
      spotifyUrl: "https://open.spotify.com/episode/1A4qwqKOaEAXq4jA4GPgw1"
    },
    {
      id: 4,
      title: "The Chop Up: The Hustle Behind Mr. Interior | Interior Design Edition",
      description: "Dive into the creative world of interior design with Mr. Interior. Learn how passion, creativity, and hustle combine to build a successful design business.",
      duration: "16:47",
      date: "Nov 14, 2024",
      image: "https://i.ytimg.com/vi/kqYGC5CQoyc/hqdefault.jpg",
      category: "Creative Business",
      isPlaying: false,
      youtubeUrl: "https://youtu.be/kqYGC5CQoyc",
      spotifyUrl: "https://open.spotify.com/episode/6Im9k8u9OHyABdk0EEHLZH"
    }
  ];

  const shorts: Short[] = [
    {
      id: 1,
      title: "Unstoppable Mindset: Conquer Every Challenge & Succeed!",
      description: "Quick mindset shift that changes everything. The power of pivoting when life demands it.",
      duration: "0:58",
      views: "1.5K",
      image: "https://i.ytimg.com/vi/DrF0KT37Uwo/oar2.jpg",
      youtubeUrl: "https://www.youtube.com/@themusclehustlepodcast"
    },
    {
      id: 2,
      title: "Staying Humble: Celebrity Life and Giving Back",
      description: "The secret formula behind every successful hustle. Small actions, massive results.",
      duration: "0:45",
      views: "615",
      image: "https://i.ytimg.com/vi/laJYtqIn-bg/oar2.jpg",
      youtubeUrl: "https://www.youtube.com/@themusclehustlepodcast"
    },
    {
      id: 3,
      title: "From Vision to Victory: Building Your Empire",
      description: "Turn your biggest dreams into reality. The step-by-step blueprint for transforming ideas into success.",
      duration: "0:52",
      views: "743",
      image: "https://i.ytimg.com/vi/CcU2nTw4Q8s/oar2.jpg",
      youtubeUrl: "https://www.youtube.com/@themusclehustlepodcast"
    },
    {
      id: 4,
      title: "Master Your Mindset: The Champion's Approach",
      description: "Develop the mental strength that separates winners from everyone else. Mindset is everything.",
      duration: "0:41",
      views: "1.1K",
      image: "https://i.ytimg.com/vi/j5K3o7vZJkE/oar2.jpg",
      youtubeUrl: "https://www.youtube.com/@themusclehustlepodcast"
    },
    {
      id: 5,
      title: "Love the Work, the Money Will Follow",
      description: "Start your day with the right energy. The morning routine that changes everything.",
      duration: "1:12",
      views: "715",
      image: "https://i.ytimg.com/vi/rDZpaRFUffU/oar2.jpg",
      youtubeUrl: "https://www.youtube.com/@themusclehustlepodcast"
    },
    {
      id: 6,
      title: "It's ok to pivot … He'll redirect you where you belong",
      description: "Transform setbacks into comebacks. Every failure is a lesson in disguise.",
      duration: "0:30",
      views: "17",
      image: "https://i.ytimg.com/vi/Hn5XIhXZDlk/oar2.jpg",
      youtubeUrl: "https://www.youtube.com/@themusclehustlepodcast"
    }
  ];

  const playOnSpotify = (spotifyUrl: string, episodeId: number) => {
    setPlayingEpisode(episodeId);
    window.open(spotifyUrl, '_blank');
    setTimeout(() => setPlayingEpisode(null), 2000);
  };

  const openYouTube = (youtubeUrl: string) => {
    window.open(youtubeUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      
      {/* Latest Episodes Section */}
      <section className="py-16 md:py-20 bg-gray-900">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6">
              Latest Episodes
            </h2>
            <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto">
              Dive into our most recent conversations with industry leaders, entrepreneurs, and visionaries who embody the hustle.
            </p>
          </div>
          
          <div className="grid gap-6 md:gap-8 max-w-7xl mx-auto">
            {episodes.map((episode) => (
              <div key={episode.id} className="bg-gray-800 border border-gray-700 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
                <div className="p-4 md:p-6 lg:p-8">
                  <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
                    <div className="flex-shrink-0 mx-auto sm:mx-0">
                      <img 
                        src={episode.image} 
                        alt={episode.title}
                        className="w-32 h-24 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-xl object-cover object-top"
                      />
                    </div>
                    
                    <div className="flex-1 text-center sm:text-left">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-3 justify-center sm:justify-start">
                        <span className="px-3 py-1 bg-red-600 text-white text-sm font-semibold rounded-full inline-block">
                          {episode.category}
                        </span>
                        <span className="text-gray-300 text-base md:text-lg">{episode.date}</span>
                      </div>
                      
                      <h3 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4 line-clamp-2 leading-tight group-hover:text-red-400 transition-colors">
                        {episode.title}
                      </h3>
                      
                      <p className="text-gray-400 text-base md:text-lg mb-4 md:mb-6 line-clamp-3 leading-relaxed">
                        {episode.description}
                      </p>
                      
                      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                        <div className="flex items-center gap-4">
                          <button 
                            onClick={() => playOnSpotify(episode.spotifyUrl, episode.id)}
                            className="w-12 h-12 flex items-center justify-center bg-red-600 hover:bg-red-700 text-white rounded-full transition-colors cursor-pointer"
                            title="Play on Spotify"
                          >
                            <i className={`${playingEpisode === episode.id ? 'ri-pause-fill' : 'ri-play-fill'} text-lg`}></i>
                          </button>
                          
                          <div className="flex items-center gap-2 text-gray-400">
                            <div className="w-4 h-4 flex items-center justify-center">
                              <i className="ri-time-line text-sm"></i>
                            </div>
                            <span className="text-gray-300 text-base md:text-lg">{episode.duration}</span>
                          </div>
                        </div>
                        
                        <div className="flex gap-2">
                          <button 
                            onClick={() => playOnSpotify(episode.spotifyUrl, episode.id)}
                            className="w-10 h-10 flex items-center justify-center bg-green-600 hover:bg-green-700 rounded-full transition-colors cursor-pointer"
                            title="Listen on Spotify"
                          >
                            <i className="ri-spotify-fill text-white"></i>
                          </button>
                          <button 
                            onClick={() => openYouTube(episode.youtubeUrl)}
                            className="w-10 h-10 flex items-center justify-center bg-white hover:bg-gray-200 rounded-full transition-colors cursor-pointer"
                            title="Watch on YouTube"
                          >
                            <i className="ri-youtube-fill text-red-600"></i>
                          </button>
                          <button className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-gray-600 rounded-full transition-colors cursor-pointer">
                            <i className="ri-share-line text-gray-300"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-8 md:mt-12">
            <button 
              onClick={() => window.open('https://www.youtube.com/@themusclehustlepodcast', '_blank')}
              className="bg-white hover:bg-gray-200 text-black px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Watch All Episodes on YouTube
            </button>
          </div>
        </div>
      </section>

      {/* YouTube Shorts Section */}
      <section className="py-16 md:py-20 bg-black">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center bg-red-600 rounded-lg">
                <i className="ri-play-circle-fill text-white text-lg md:text-xl"></i>
              </div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">YouTube Shorts</h2>
            </div>
            <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto">
              Quick doses of motivation and wisdom. Bite-sized content that packs a punch for your daily hustle.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 max-w-7xl mx-auto">
            {shorts.map((short) => (
              <div 
                key={short.id} 
                className="group cursor-pointer"
                onMouseEnter={() => setHoveredShort(short.id)}
                onMouseLeave={() => setHoveredShort(null)}
                onClick={() => openYouTube(short.youtubeUrl)}
              >
                <div className="relative bg-gray-900 rounded-2xl overflow-hidden aspect-[3/4] hover:scale-105 transition-all duration-300">
                  <img 
                    src={short.image} 
                    alt={short.title}
                    className="w-full h-full object-cover object-top"
                  />
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                  
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-red-600/90 rounded-full">
                      <i className="ri-play-fill text-white text-lg md:text-2xl ml-1"></i>
                    </div>
                  </div>
                  
                  <div className="absolute top-2 md:top-3 right-2 md:right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-full">
                    {short.duration}
                  </div>
                  
                  <div className="absolute top-2 md:top-3 left-2 md:left-3 bg-red-600/90 text-white text-xs px-2 py-1 rounded-full font-semibold">
                    {short.views} views
                  </div>
                  
                  <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                    <h3 className="text-white font-bold text-sm md:text-base lg:text-lg mb-1 line-clamp-2 leading-tight">
                      {short.title}
                    </h3>
                    <p className="text-gray-300 text-xs md:text-sm line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 leading-tight">
                      {short.description}
                    </p>
                  </div>
                  
                  <div className="absolute bottom-2 md:bottom-3 right-2 md:right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-red-600 rounded-full">
                      <i className="ri-youtube-fill text-white text-xs md:text-sm"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-8 md:mt-12">
            <button 
              onClick={() => window.open('https://www.youtube.com/@themusclehustlepodcast', '_blank')}
              className="bg-red-600 hover:bg-red-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Watch More Shorts
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
